// Saga for running the GMA test timer client side
import { put, delay, takeLatest, select, call } from 'redux-saga/effects'
import { START_TIMER, getTimer, updateTimer } from 'ducks/timer'
import { getGMA, finishGMA } from 'ducks/respondent'

function* timerSaga() {
  yield takeLatest(START_TIMER, runTimer)
}

export default timerSaga

function* runTimer(action) {
  // runs the timer if gma has status started, if not, stop the timer
  const { status, started, secondsTotal, secondsLeft, timeDelta } =
    yield select(getGMA)
  if (started && secondsTotal && secondsLeft && status === 'started') {
    // start countdown generator
    yield put(
      updateTimer({
        started: new Date(started).valueOf() - timeDelta * 1000,
        secondsTotal,
        secondsLeft,
      }),
    )
    yield* tickTock()
    yield put(finishGMA({ reason: 'time ran out' }))
  }
}

function* tickTock() {
  // dispatches redux updateTimer actions every second
  // keep track of start time, to be more accurate than using the browser
  // builtin window.setInterval
  let { started, secondsTotal, secondsLeft } = yield select(getTimer)
  while (secondsLeft) {
    // We try to accurately tick once every 1000 milliseconds
    const currentTime = yield call(Date.now)
    const millisecondsElapsed = Math.max(0, currentTime - started)
    const tickMilliseconds = 1000 - (millisecondsElapsed % 1000)
    const secondsElapsed = Math.round(millisecondsElapsed / 1000)
    secondsLeft = Math.max(0, secondsTotal - secondsElapsed)
    yield put(updateTimer({ secondsLeft }))
    yield delay(tickMilliseconds)
  }
}
